import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import ContactCustomerService from 'components/ContactCustomerService';
import BodyText from 'components/widget/BodyText';

const TechnicalErrorWidgetContainer = styled.div`
  ${Button} {
    margin-bottom: ${({ theme }) => theme.spacing * 2}px;
  }
`;

const TechnicalErrorPage = ({
  title,
  message,
  displayButton,
  customerServicePhoneNumber,
  errorName,
}) => {
  // error name list available here:
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException#Error_names
  const errorMap = {
    SecurityError: {
      title: 'Change your browser settings to continue',
      message: (
        <>
          <p>
            <BodyText>
              Your browser settings do not currently allow cookies which is
              blocking you from using this service. Cookies are small text files,
              downloaded from websites to your computer or smartphone as you
              browse and use the Internet.
            </BodyText>
          </p>
          <p>
            <BodyText>
              To use this service you need to change your browser settings to
              allow cookies. Check the online help in your browser to learn more.
            </BodyText>
          </p>
        </>
      ),
      component: null,
    },
    default: {
      title: "Oops, something's gone wrong",
      message: (
        <p>
          We&apos;re sorry but we&apos;ve had a problem connecting to your
          easycare account. Try loading the details again or call us on the
          number below for more help.
        </p>
      ),
      component: (
        <>
          <ContactCustomerService phoneNumber={customerServicePhoneNumber} />
        </>
      ),
    },
  };
  return (
    <TechnicalErrorWidgetContainer>
      <h2>
        {title
          || (errorMap[errorName] && errorMap[errorName].title)
          || errorMap.default.title}
      </h2>

      {
        (message && <p>{message}</p>)
        || (errorMap[errorName] && errorMap[errorName].message)
        || errorMap.default.message
      }

      {displayButton && (
        <Button
          type="button"
          onClick={() => window.location.reload()}
          fullWidth
          inverse
        >
          Try reloading the page
        </Button>
      )}
      {errorMap[errorName] !== undefined
        ? errorMap[errorName].component
        : errorMap.default.component}
    </TechnicalErrorWidgetContainer>
  );
};

export default TechnicalErrorPage;

TechnicalErrorPage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.element,
  errorName: PropTypes.string,
  customerServicePhoneNumber: PropTypes.string.isRequired,
  displayButton: PropTypes.bool,
};

TechnicalErrorPage.defaultProps = {
  title: null,
  message: null,
  errorName: null,
  displayButton: false,
};
